import React, { useEffect, useMemo, useState } from 'react'
import SuperSearchSingleClient from '../../../../../../../../shared/SuperSearch/SingleSelection/SuperSearchSingleClient';
import isNull from '../../../../../../../../../utils/NullChecking';
import { connect, useSelector } from 'react-redux';
import { enumUtil } from '../../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../../utils/ServerDataRequest';
import Loader from '../../../../../../../../shared/Loader/Loader';
import { format } from 'date-fns';
import DropdownValueHandler from '../../../../../../../../shared/SuperSearch/DropdownValueHandler';
import handleSetDropdownData from '../../../../../../../../../utils/HandleSetDropdownData';
import { currentMentalStatusItems, interventionCategories, riskAssessmentItems } from '../../../../EncounterRightPortion/TemplateView/Components/utils';
import { GeneralDropDowns } from '../../../../../../../../../actions/GeneralPatientActions';
import { useDispatch } from 'react-redux';
import { TabActionEncounterMenu } from '../../../../../../../../../actions/EncounterMenuActions';

const PastEncounters = ({ expandAll, ...props }) => {
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let dispatch = useDispatch();
    const [is, setIs] = useState(true);
    const ENCOUNTER_MODEL = {
        "EncounterID": "",
    }
    const [saveEncounterParam, setSaveEncounterParam] = useState(ENCOUNTER_MODEL);
    const SearchEncounterName = {
        "EncounterID": "",
    }
    let ENCOUNTER_DEFAULT_MODEL = {
        "TableName": enumUtil.enumAPITableName.Encounter,
        "Data": {
            "EncounterID": "",
            "PatientID": props?.patientID || "",
            "EncounterType": "",
            "NoteType": "",
            "EncounterDate": format(new Date(), 'MM/dd/yyyy'),
            "SeenBy": "",
            "Facility": "",
            "EncounterStatus": "",
            "ChiefComplaint": "",
            "SubjectiveNotes": "",
            "ObjectiveNotes": "",
            "AssesmentNotes": "",
            "PlanNotes": "",
            "AdditionalInfoNotes": ""
        },
        "Vital": [],
        "EncounterProblem": [],
        "EncounterDocument": [],
        "EncounterAddendum": []
    };
    ////=== Loader ===////
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDD, setIsLoadingDD] = useState(false);
    const [isLoadingPastEncounter, setIsLoadingPastEncounter] = useState(false);
    ///////========///////
    const [encounterData, setEncounterData] = useState(ENCOUNTER_DEFAULT_MODEL);
    const [searchValue, setSearchValue] = useState(SearchEncounterName)

    const API_URL_GENERAL = enumUtil.controller.General;
    const API_URL_PATIENT_ENCOUNTER = enumUtil.controller.PatientEncounter;

    const [encountersDDData, setEncountersDDData] = useState([]);
    const [itemsCollapsed, setItemsCollapsed] = useState({});

    const LoadDDData = () => {
        setIsLoadingDD(true);
        setEncountersDDData([])
        ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": props?.patientID,
            "SearchCriteria": {
                "Param": "PastEncounter"
            }
        })
            .then((response) => {
                setIsLoadingDD(false);
                setEncountersDDData(response.Rows);
                // setIs(true);
            }).catch((error) => {
                setIsLoadingDD(false);
            })
    }

    const LoadPastEncounterID = () => {
        setIsLoadingPastEncounter(true);
        ServerRequestProtected(API_URL_GENERAL + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": props?.patientID,
            "SearchCriteria": {
                "Param": "PastEncounter"
            }
        })
            .then((response) => {
                setIsLoadingPastEncounter(false);
                if (!response?.EncounterID || !response?.display) return
                handleSelectedData({
                    value: String(response?.EncounterID),
                    display: response?.display,
                    NoteType: response?.NoteType,
                }, 'EncounterID', 'client');
            }).catch((error) => {
                setIsLoadingPastEncounter(false);
            })
    }

    const LoadEncounterData = (selectedData) => {
        let encounterID = selectedData.value;
        let APIURL_NoteType = selectedData.NoteType === 'SOAP' ?
            "/GetSOAPEncounter" :
            selectedData.NoteType === 'GIRP' ?
                "/GetGIRPNote" :
                selectedData.NoteType === 'BIRP' ?
                    "/GetBIRPNote" :
                    selectedData.NoteType === 'DAP' ?
                        "/GetDAPNote" :
                    selectedData.NoteType === 'DAPP' ?
                        "/GetDAPPNote" :
                        selectedData.NoteType === 'Therapy' ?
                            "/GetTherapyNote" :
                            selectedData.NoteType === 'Massage' ?
                                "/GetMassageNote" :
                                selectedData.NoteType === 'Physical' ?
                                    "/GetPhysicalNote" :
                                    selectedData.NoteType === 'Other' ?
                                        "/GetOtherNote" : "/GetCustomNote";

        let Tablename = selectedData.NoteType === 'SOAP' ?
            enumUtil.enumAPITableName.Encounter :
            selectedData.NoteType === 'GIRP' ?
                enumUtil.enumAPITableName.GIRPNote :
                selectedData.NoteType === 'BIRP' ?
                    enumUtil.enumAPITableName.BIRPNote :
                    selectedData.NoteType === 'DAP' ?
                        enumUtil.enumAPITableName.DAPNote :
                    selectedData.NoteType === 'DAPP' ?
                        enumUtil.enumAPITableName.DAPPNote :
                        selectedData.NoteType === 'Therapy' ?
                            enumUtil.enumAPITableName.TherapyNote :
                            selectedData.NoteType === 'Massage' ?
                                enumUtil.enumAPITableName.MassageNote :
                                selectedData.NoteType === 'Physical' ?
                                    enumUtil.enumAPITableName.PhysicalNote :
                                    selectedData.NoteType === 'Other' ?
                                        enumUtil.enumAPITableName.OtherNote : enumUtil.enumAPITableName.CustomNote;

        if (['-1', -1, 0, "", null, undefined].includes(encounterID)) return;

        setEncounterData(ENCOUNTER_DEFAULT_MODEL);
        setIsLoading(true);

        ServerRequestProtected(API_URL_PATIENT_ENCOUNTER + APIURL_NoteType, 'post', {
            "TableName": Tablename,
            "ID": encounterID,
        })
            .then((response) => {
                setIsLoading(false);

                setEncounterData(prev => ({
                    ...prev,
                    ...response,
                    Data: { ...prev?.Data, ...response?.Data }
                }));
                setItemsCollapsed({});

                setIs(true);
            }).catch((error) => {
                setIsLoading(false)
            })
    }

    useEffect(() => {
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 218) {
                    LoadDDData();
                    LoadPastEncounterID();
                }
            })
            if (data.length === 0) {
                LoadDDData();
                LoadPastEncounterID();
            }
        }
    }, [props.Reload])

    const handleSelectedData = (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {
            setIs(true);
            if (name === 'EncounterID') {
                console.log("EncounterIDname", selectedData, name, type)
                setSaveEncounterParam({ ...saveEncounterParam, EncounterID: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterID: selectedData.display + "" }))
                LoadEncounterData(selectedData)
            }
        } else {
            setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
            setSearchValue(prev => ({ ...prev, [name]: "" }))
        }
        return selectedData
    }

    let vitalData = encounterData?.Vital?.[0]?.Vital?.reduce((acc, curr) => {
        acc[curr.VitalName] = curr.VitalValue;
        return acc;
    }, {});
    let { Data, EncounterDocument, EncounterProblem } = encounterData;

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }
    let noValExistText = <p className="fst-italic light-clrs text">No data recorded</p>;

    // US Customary Units
    const vitalUnitListUS = {
        Height: "in",
        Weight: "lb",
        BMI: "",
        "BMI Percentile": "%",
        BP: "mmHg",
        Temperature: "°F",
        Pulse: "bpm",
        "Respiratory Rate": "breaths/min",
        "O2 Saturation": "%",
        Pain: "",
        "Head Circumference": "in"
    };

    // Metric Units
    const vitalUnitListMetric = {
        Height: "cm",
        Weight: "kg",
        BMI: "",
        "BMI Percentile": "%",
        BP: "mmHg",
        Temperature: "°C",
        Pulse: "bpm",
        "Respiratory Rate": "breaths/min",
        "O2 Saturation": "%",
        Pain: "",
        "Head Circumference": "cm"
    };

    // Empty (Else Case)
    const vitalUnitListEmpty = {
        Height: "",
        Weight: "",
        BMI: "",
        "BMI Percentile": "",
        BP: "",
        Temperature: "",
        Pulse: "",
        "Respiratory Rate": "",
        "O2 Saturation": "",
        Pain: "",
        "Head Circumference": ""
    };

    const vitalUnitList = useMemo(() => {
        if (Data?.VitalUnitType === "US Customary") {
            return vitalUnitListUS;
        } else if (Data?.VitalUnitType === "Metric") {
            return vitalUnitListMetric;
        }
        return vitalUnitListEmpty; // fallback empty object
    }, [Data?.VitalUnitType]);

    //// Item Collapse ////
    const handleItemsExpanded = (name) => {
        setItemsCollapsed(prev => ({ ...prev, [name]: !prev[name] }))
    }

    let noData = <span className="text fs-11 light-clrs fst-italic">N/A</span>;
    /// TherapyNote ///
    const [cmsDDData, setCMSDDData] = useState({});
    useEffect(() => {
        // Current Mental Status Dropdown //
        if (!DropDowns?.TherapyNote || Object.keys(DropDowns.TherapyNote).length === 0) {
            ServerRequestProtected(API_URL_PATIENT_ENCOUNTER + "/EncounterDropDown", 'post', {
                "TableName": enumUtil.enumAPITableName.EncounterDropDown,
                "ID": props?.patientID,
            })
                .then((response) => {
                    dispatch(GeneralDropDowns({ ...DropDowns, TherapyNote: response }));
                    setCMSDDData(response)
                }).catch((error) => {
                })
        } else {
            setCMSDDData(DropDowns?.TherapyNote)
        }

    }, [])

    let currentMentalStatusData = useMemo(() => {
        const { TableNameCMS, ...cmsData } = encounterData?.CurrentMentalStatus || {};
        return Object.keys(cmsData).reduce((acc, key) => {
            acc[key] = DropdownValueHandler(cmsDDData[key], cmsData[key]) ?? "";
            return acc;
        }, {});
    }, [encounterData?.CurrentMentalStatus, cmsDDData]);

    const handleOpenEncounter = () => {
        console.log("encounterhandleOpenEncounter", saveEncounterParam,encountersDDData,)
        let encounter = encountersDDData.find(enc => enc.value === saveEncounterParam?.EncounterID)
        // return;
        if(props?.isCalledFrom === 'EncounterMenu'){
            let obj = {
                active: true,
                key: 2,
                name: "Encounter Menu",
                data: {
                    name: `${encounter?.FirstName || 'Patient First Name'} - ${encounter?.display?.split(' - ')?.[0] || 'Date'}`,
                    id: encounter.value,
                    patid: encounter.PatientID,
                    type: encounter.NoteType,
                    time: new Date()
                },
            }
            console.log(
                "encounterhandleOpenEncounter", 
                props?.isCalledFrom, obj);
                
            props?.TabActionEncounterMenu(obj);
        } else {
            let obj = {
                active: true,
                key: 2,
                name: "Encounter",
                data: {
                    name: `${encounter?.display?.split(' - ')?.[0] || 'Date'}`,
                    id: encounter?.value,
                    // patID: PatientIDR,
                    type: encounter.NoteType,
                    time: new Date()
                },
            }     
            dispatch({
                type: 'Open_Encounter_Tab',
                payload: {
                    patientId: props?.patientID,     // <-- needed to find the patient tab to update
                    tab: obj            // the encounter tab object
                }
            });
        }   
    }
    const HeaderIcon = () => {
        if(props?.isCalledFrom === 'ClaimEncounter'){
            return (<></>);
        } else {
        return(
        <div className='d-flex align-items-center gap-1'>
            {/* <p className='text font-m validate-color text-decoration-underline cursor-pointer'>Repeat</p> */}
            <i className="fs-9 icon-merge-top-right" onClick={handleOpenEncounter}></i>
        </div>);
        }
    }

    
    const CustomNoteHeaderIcon = () => {
        if(props?.isCalledFrom === 'ClaimEncounter'){
            return (<></>);
        } else {
        return(
            <div className="d-flex align-items-center gap-1 cursor-pointer user-select-none w-max-content" onClick={handleOpenEncounter}>
                <p className='heading font-m validate-color w-max-content' >View Encounter</p>
                <div className='d-flex align-items-center gap-1'>
                    <i className="fs-9 icon-merge-top-right"></i>
                </div>
            </div>);
        }
    }
    const encounterId = saveEncounterParam?.EncounterID;
    const isEncounterNotSystemGenerated = !!encounterId && encountersDDData?.find(enc => enc.value === encounterId)?.IsSystemGenerated === "false";

    console.log("PAST123isEncounterNotSystemGenerated",isEncounterNotSystemGenerated)
    return (
        <div>
            {(isLoading || isLoadingDD || isLoadingPastEncounter) ? <Loader /> : null}
            <div className="mb-12 d-flex flex-column gap-12">
                <p className='heading fs-14 px-2'>PAST ENCOUNTERS</p>
                <div className="ar-multiple-br">
                    <SuperSearchSingleClient
                        type="client"
                        id='EncounterID'
                        name='EncounterID'
                        icon={'Simple'}
                        sup_btn='sup_btn'
                        sup_inp='superSearchVisitInp'
                        searchValue={searchValue.EncounterID}
                        data={handleSetDropdownData(encountersDDData, { functions: ['removeNegativeValue', 'removeSelfPay', 'setEmptyDefault'] })}
                        onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterID: e.target.value }) }}
                        getSelectedData={handleSelectedData}
                        is={is}
                        placeholder={false}
                        SuperSearchView="DetailedView"
                        DetailedView="PatientPastEncounter"
                    />
                </div>
            </div>
            {saveEncounterParam?.EncounterID ?
                <div className="d-flex flex-column gap-12">
                    {Data?.NoteType === 'SOAP' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Subjective')}>Subjective</p>
                                    <HeaderIcon/>
                                </div>
                                {!itemsCollapsed?.['Subjective'] &&
                                    <div className='mt-12'>
                                        <div className="" >
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                            <div className="">
                                                {!itemsCollapsed?.['CC'] &&
                                                    (Data?.ChiefComplaint ?
                                                        <p className="text">{Data?.ChiefComplaint}</p> : noValExistText)}
                                                {/* <p className='text ar-dot'>Patient presents with persistent cough,</p>
                                <p className='text ar-dot'>fatigue, and shortness of breath over the</p>
                                <p className='text ar-dot'>past two weeks.</p> */}
                                            </div>
                                        </div>
                                        {/* <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('HPI')}>History of Present Illness</p>
                                            {!itemsCollapsed?.['HPI'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.HistoryofPresentIllnessNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.HistoryofPresentIllnessNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('ROS')}>Review of System</p>
                                            {!itemsCollapsed?.['ROS'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.ReviewOfSystemNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ReviewOfSystemNotes || '' }}></p>}
                                                </div>)}
                                        </div> */}
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('SN')}>Notes</p>
                                            {!itemsCollapsed?.['SN'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.SubjectiveNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.SubjectiveNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Objective')}>Objective</p>
                                </div>
                                {!itemsCollapsed?.['Objective'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('V')}>Vitals</p>
                                            {!itemsCollapsed?.['V'] &&
                                                <div className='d-flex flex-column gap-10 px-1'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>Height</p>
                                                        <p className='text'>
                                                            {vitalData?.Height ? `${vitalData?.Height} ${vitalUnitList?.Height}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>Weight</p>
                                                        <p className='text'>
                                                            {vitalData?.Weight ? `${vitalData?.Weight} ${vitalUnitList?.Weight}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>BMI</p>
                                                        <p className='text'>
                                                            {vitalData?.BMI ? `${vitalData?.BMI} ${vitalUnitList?.BMI}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>BMI Percentile</p>
                                                        <p className='text'>
                                                            {vitalData?.['BMI Percentile'] ? `${vitalData?.['BMI Percentile']} ${vitalUnitList?.['BMI Percentile']}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>BP</p>
                                                        <p className='text'>
                                                            {vitalData?.BP ? `${vitalData?.BP} ${vitalUnitList?.BP}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>Temperature</p>
                                                        <p className='text'>
                                                            {vitalData?.Temperature ? `${vitalData?.Temperature} ${vitalUnitList?.Temperature}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>Pulse</p>
                                                        <p className='text'>
                                                            {vitalData?.Pulse ? `${vitalData?.Pulse} ${vitalUnitList?.Pulse}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>Respiratory Rate</p>
                                                        <p className='text'>
                                                            {vitalData?.['Respiratory Rate'] ? `${vitalData?.['Respiratory Rate']} ${vitalUnitList?.['Respiratory Rate']}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>O2 Saturation</p>
                                                        <p className='text'>
                                                            {vitalData?.['O2 Saturation'] ? `${vitalData?.['O2 Saturation']} ${vitalUnitList?.['O2 Saturation']}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>Pain</p>
                                                        <p className='text'>
                                                            {vitalData?.Pain ? `${vitalData?.Pain} ${vitalUnitList?.Pain}` : '_'}
                                                        </p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className='text font-m'>Head Circumference</p>
                                                        <p className='text'>
                                                            {vitalData?.['Head Circumference'] ? `${vitalData?.['Head Circumference']} ${vitalUnitList?.['Head Circumference']}` : '_'}
                                                        </p>
                                                    </div>
                                                </div>}

                                        </div>

                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('ON')}>Notes</p>
                                            {!itemsCollapsed?.['ON'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.ObjectiveNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ObjectiveNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('Observations')}>Observations</p>
                                            {!itemsCollapsed?.['Observations'] &&
                                                (<div className="d-flex flex-column gap-2 mt-2">
                                                    <div className="">
                                                        <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content'>Cognitive Status</p>
                                                        {/* /////// Cognitive Status //////// */}
                                                        {encounterData?.CognitiveStatus?.length > 0 ?
                                                            (<div className="d-flex flex-column gap-1">
                                                                {encounterData?.CognitiveStatus?.map(cognItem => {
                                                                    let display = cognItem?.CognitiveStatusValues?.split("-").map(part => part.trim());
                                                                    return (
                                                                        <div className="">
                                                                            <p className='text mb-1'>{display?.[1]} <span className='validate-color cursor-pointer'>- {display?.[0]}</span></p>
                                                                            <p className='text'><span className='font-m'>Date:</span> {cognItem?.CognitiveDate || noData}</p>
                                                                        </div>)
                                                                })}
                                                            </div>) : noValExistText}
                                                    </div>
                                                    <div className="">
                                                        <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content'>Functional Status</p>
                                                        {/* /////// Functional Status //////// */}
                                                        {encounterData?.FunctionalStatus?.length > 0 ?
                                                            (<div className="d-flex flex-column gap-1">
                                                                {encounterData?.FunctionalStatus?.map(funcItem => {
                                                                    let display = funcItem?.FunctionalStatusValues?.split("-").map(part => part.trim());
                                                                    return (
                                                                        <div className="">
                                                                            <p className='text mb-1'>{display?.[1]} <span className='validate-color cursor-pointer'>- {display?.[0]}</span></p>
                                                                            <p className='text'><span className='font-m'>Date:</span> {funcItem?.FunctionalDate || noData}</p>
                                                                        </div>)
                                                                })}
                                                            </div>) : noValExistText}

                                                    </div>
                                                </div>)}

                                        </div>

                                    </div>}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Assessment')}>Assessment</p>
                                </div>
                                {!itemsCollapsed?.['Assessment'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('P')}>Problems</p>
                                            {!itemsCollapsed?.['P'] &&
                                                (<div className="d-flex flex-column gap-2">
                                                    {EncounterProblem?.length > 0 ?
                                                        <div
                                                        >
                                                            {EncounterProblem.map(prob => (
                                                                <div className="">
                                                                    <p className='text validate-color'>{prob.DiagnosisCode}</p>
                                                                    <p className='text px-1 light_bg text-nowrap validation_message my-1'>{prob.Description || noData}</p>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <p className='heading'>Start Date: <span className='font-r'>{prob.StartDate || noData}</span></p>
                                                                        <p className='heading'>{prob.Acuity || noData}</p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div> : <>{noValExistText}</>}
                                                </div>)}
                                        </div>

                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('AN')}>Notes</p>
                                            {!itemsCollapsed?.['AN'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.AssesmentNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AssesmentNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Plan')}>Plan</p>
                                </div>
                                {!itemsCollapsed?.['Plan'] &&
                                    (<div className='mt-12'>
                                        <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('PN')}>Notes</p>
                                        {!itemsCollapsed?.['PN'] &&
                                            <div className="">
                                                {isVisuallyEmpty(Data.PlanNotes) ?
                                                    noValExistText :
                                                    <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                            </div>}
                                    </div>)}
                            </div>
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] &&
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :
                    Data?.NoteType === 'GIRP' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('P')}>Problems</p>
                                    {!itemsCollapsed?.['P'] &&
                                        <div className="d-flex flex-column gap-2 mt-12">
                                            {EncounterProblem?.length > 0 ?
                                                <div
                                                >
                                                    {EncounterProblem.map(prob => (
                                                        <div className="">
                                                            <p className='text validate-color'>{prob.DiagnosisCode}</p>
                                                            <p className='text px-1 light_bg text-nowrap validation_message my-1'>{prob.Description || noData}</p>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className='heading'>Start Date: <span className='font-r'>{prob.StartDate || noData}</span></p>
                                                                <p className='heading'>{prob.Acuity || noData}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div> : <>{noValExistText}</>}
                                        </div>}
                                </div>
                            </div>

                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('G')}>Goals</p>
                                {!itemsCollapsed?.['G'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.GoalsNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.GoalsNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('I')}>Intervention</p>
                                {!itemsCollapsed?.['I'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.InterventionNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.InterventionNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('R')}>Response</p>
                                {!itemsCollapsed?.['R'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.ResponseNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ResponseNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Plan')}>Plan</p>
                                {!itemsCollapsed?.['Plan'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.PlanNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                    </div>)}
                            </div>

                            {/* Additional Info */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] && (
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :
                    Data?.NoteType === 'BIRP' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('P')}>Problems</p>
                                    {!itemsCollapsed?.['P'] &&
                                        <div className="d-flex flex-column gap-2 mt-12">
                                            {EncounterProblem?.length > 0 ?
                                                <div
                                                >
                                                    {EncounterProblem.map(prob => (
                                                        <div className="">
                                                            <p className='text validate-color'>{prob.DiagnosisCode}</p>
                                                            <p className='text px-1 light_bg text-nowrap validation_message my-1'>{prob.Description || noData}</p>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className='heading'>Start Date: <span className='font-r'>{prob.StartDate || noData}</span></p>
                                                                <p className='heading'>{prob.Acuity || noData}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div> : <>{noValExistText}</>}
                                        </div>}
                                </div>
                            </div>

                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('B')}>Behaviour</p>
                                {!itemsCollapsed?.['B'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.BehaviourNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.BehaviourNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('I')}>Intervention</p>
                                {!itemsCollapsed?.['I'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.InterventionNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.InterventionNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('R')}>Response</p>
                                {!itemsCollapsed?.['R'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.ResponseNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ResponseNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Plan')}>Plan</p>
                                {!itemsCollapsed?.['Plan'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.PlanNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                    </div>)}
                            </div>

                            {/* Additional Info */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] && (
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :
                    Data?.NoteType === 'DAP' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('P')}>Problems</p>
                                    {!itemsCollapsed?.['P'] &&
                                        <div className="d-flex flex-column gap-2 mt-12">
                                            {EncounterProblem?.length > 0 ?
                                                <div
                                                >
                                                    {EncounterProblem.map(prob => (
                                                        <div className="">
                                                            <p className='text validate-color'>{prob.DiagnosisCode}</p>
                                                            <p className='text px-1 light_bg text-nowrap validation_message my-1'>{prob.Description || noData}</p>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className='heading'>Start Date: <span className='font-r'>{prob.StartDate || noData}</span></p>
                                                                <p className='heading'>{prob.Acuity || noData}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div> : <>{noValExistText}</>}
                                        </div>}
                                </div>
                            </div>

                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Data')}>Data</p>
                                {!itemsCollapsed?.['Data'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.DataNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.DataNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('A')}>Assessment</p>
                                {!itemsCollapsed?.['A'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.AssesmentNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AssesmentNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Plan')}>Plan</p>
                                {!itemsCollapsed?.['Plan'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.PlanNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                    </div>)}
                            </div>

                            {/* Additional Info */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] && (
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :
                    Data?.NoteType === 'DAPP' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('P')}>Problems</p>
                                    {!itemsCollapsed?.['P'] &&
                                        <div className="d-flex flex-column gap-2 mt-12">
                                            {EncounterProblem?.length > 0 ?
                                                <div
                                                >
                                                    {EncounterProblem.map(prob => (
                                                        <div className="">
                                                            <p className='text validate-color'>{prob.DiagnosisCode}</p>
                                                            <p className='text px-1 light_bg text-nowrap validation_message my-1'>{prob.Description || noData}</p>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className='heading'>Start Date: <span className='font-r'>{prob.StartDate || noData}</span></p>
                                                                <p className='heading'>{prob.Acuity || noData}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div> : <>{noValExistText}</>}
                                        </div>}
                                </div>
                            </div>

                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Data')}>Data</p>
                                {!itemsCollapsed?.['Data'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.DataNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.DataNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('A')}>Assessment</p>
                                {!itemsCollapsed?.['A'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.AssesmentNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AssesmentNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('PR')}>Progress</p>
                                {!itemsCollapsed?.['PR'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.ProgressNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ProgressNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Plan')}>Plan</p>
                                {!itemsCollapsed?.['Plan'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.PlanNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                    </div>)}
                            </div>

                            {/* Additional Info */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] && (
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :

                    Data?.NoteType === 'Therapy' ?
                        <>
                            <div className=''>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('P')}>Problems</p>
                                    {!itemsCollapsed?.['P'] &&
                                        <div className="d-flex flex-column gap-2 mt-12">
                                            {EncounterProblem?.length > 0 ?
                                                <div
                                                >
                                                    {EncounterProblem.map(prob => (
                                                        <div className="">
                                                            <p className='text validate-color'>{prob.DiagnosisCode}</p>
                                                            <p className='text px-1 light_bg text-nowrap validation_message my-1'>{prob.Description || noData}</p>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className='heading'>Start Date: <span className='font-r'>{prob.StartDate || noData}</span></p>
                                                                <p className='heading'>{prob.Acuity || noData}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div> : <>{noValExistText}</>}
                                        </div>}
                                </div>
                            </div>

                            {/* Objective */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('OBJECTIVE')}>Objective</p>
                                </div>
                                {!itemsCollapsed?.['OBJECTIVE'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('CMS')}>Current Mental Status</p>
                                            {!itemsCollapsed?.['CMS'] && (
                                                <div className="">
                                                    <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
                                                        {(() => {
                                                            // Filter only those that have values
                                                            const filledVitals = currentMentalStatusItems.filter(v => currentMentalStatusData?.[v.key]);
                                                            if (filledVitals?.length === 0) return noValExistText;
                                                            // Map them into JSX
                                                            return filledVitals.map((v, index) => (
                                                                <React.Fragment key={v.key}>
                                                                    {v.label}:{" "}
                                                                    <span className=" text">
                                                                        {`${currentMentalStatusData[v.key]}`}
                                                                        {index < filledVitals.length - 1 && ", "}
                                                                    </span>

                                                                </React.Fragment>
                                                            ));
                                                        })()}
                                                    </p>

                                                </div>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('ON')}>Notes</p>
                                            {!itemsCollapsed?.['ON'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.ObjectiveNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ObjectiveNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                            {/* Intervention */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('INTERVENTION')}>Intervention</p>
                                </div>
                                {!itemsCollapsed?.['INTERVENTION'] &&
                                    <div className='mt-12'>
                                        <div className="mb-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('Int IN')}>Notes</p>
                                            {!itemsCollapsed?.['Int IN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.InterventionNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.InterventionNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IntUsed')}>Interventions Used</p>
                                            {!itemsCollapsed?.['IntUsed'] && (
                                                <div className="d-flex flex-column gap-2">
                                                    {Object.entries(interventionCategories).map(([category, children]) => {
                                                        // filter children that exist and are "true" in data
                                                        const checkedChildren = children.filter(child => encounterData?.InterventionsUsed?.[child.key] === "true");

                                                        if (checkedChildren.length === 0) return null; // skip empty category

                                                        return (
                                                            <div className="d-flex flex-column gap-2" key={category}>
                                                                <p className="heading  min-w-160px">{category}:</p>
                                                                <div className="d-flex flex-column gap-1 w-100">
                                                                    {checkedChildren.map(child => (
                                                                        <div className="d-flex align-items-center gap-6 blue-tick" key={child.key}>
                                                                            <i className="icon-check fs-15 fw-900"></i>
                                                                            <p className="text ">{child.label}</p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                    {/* // Show message if no interventions are checked */}
                                                    {!Object.values(encounterData?.InterventionsUsed || {}).some(val => val === "true") && noValExistText}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>

                            {/* Response */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('RESPONSE')}>Response</p>
                                </div>
                                {!itemsCollapsed?.['RESPONSE'] &&
                                    <div className='mt-12'>
                                        <div className="mb-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('RN')}>Notes</p>
                                            {!itemsCollapsed?.['RN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.ResponseNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ResponseNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('RO')}>Response Observations</p>
                                            {!itemsCollapsed?.['RO'] && (
                                                <div className="d-flex align-items-center gap-12 flex-wrap row-gap-5">
                                                    {Object.entries(encounterData?.ResponseObservations || {}).map(([key, value]) => {
                                                        // Only render if value exists
                                                        if (!(value === "true")) {
                                                            return null;
                                                        }
                                                        return (
                                                            <div className="d-flex align-items-center gap-6 blue-tick" key={key}>
                                                                <i className="icon-check fs-15 fw-900"></i>
                                                                <p className="text ">{key}</p>
                                                            </div>
                                                        );
                                                    })}
                                                    {!Object.values(encounterData?.ResponseObservations || {}).some(val => val === "true") && noValExistText}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>

                            {/* Assessment */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('ASSESSMENT')}>Assessment</p>
                                </div>
                                {!itemsCollapsed?.['ASSESSMENT'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('ARA')}>Risk Assessment</p>
                                            {!itemsCollapsed?.['ARA'] && (
                                                (encounterData?.RiskAssessment || [])?.length > 0 ?
                                                    (encounterData?.RiskAssessment || [])?.map(assessment => {
                                                        { console.log("RiskAssessment1123 assessment", assessment) }

                                                        // Filter only those that have values
                                                        const filledRiskAssessment = riskAssessmentItems.filter(ra => assessment?.[ra.key]);
                                                        { console.log("RiskAssessment223 filledRiskAssessment", filledRiskAssessment) }
                                                        // if (filledRiskAssessment?.length === 0) return noValExistText;
                                                        // Map them into JSX
                                                        return (<div className="d-flex align-items-center gap-1 flex-wrap">
                                                            <p className='text font-m cursor-pointer validate-color'>{assessment?.AreaOfRisk || 'N/A'}</p>
                                                            {filledRiskAssessment.map((v, index) => (
                                                                <>
                                                                    <p className='heading'>{v.label}{" "}</p>
                                                                    <p className='text'>{`${assessment[v.key]}`}{index <filledRiskAssessment.length - 1 && ", "}</p>
                                                                </>
                                                            ))}
                                                        </div>)
                                                    }) : noValExistText)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('ANotes')}>Notes</p>
                                            {!itemsCollapsed?.['ANotes'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.AssesmentNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AssesmentNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                            {/* Plan */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('PLAN')}>Plan</p>
                                </div>
                                {!itemsCollapsed?.['PLAN'] &&
                                    <div className='mt-12'>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('PN')}>Notes</p>
                                            {!itemsCollapsed?.['PN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.PlanNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                            {/* Additional Info */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] && (
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :

                    Data?.NoteType === 'Other' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>

                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('V')}>Vitals</p>
                                    {!itemsCollapsed?.['V'] &&
                                        (<div className='d-flex flex-column gap-10 px-1 mt-12'>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>Height</p>
                                                <p className='text'>
                                                    {vitalData?.Height ? `${vitalData?.Height} ${vitalUnitList?.Height}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>Weight</p>
                                                <p className='text'>
                                                    {vitalData?.Weight ? `${vitalData?.Weight} ${vitalUnitList?.Weight}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>BMI</p>
                                                <p className='text'>
                                                    {vitalData?.BMI ? `${vitalData?.BMI} ${vitalUnitList?.BMI}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>BMI Percentile</p>
                                                <p className='text'>
                                                    {vitalData?.['BMI Percentile'] ? `${vitalData?.['BMI Percentile']} ${vitalUnitList?.['BMI Percentile']}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>BP</p>
                                                <p className='text'>
                                                    {vitalData?.BP ? `${vitalData?.BP} ${vitalUnitList?.BP}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>Temperature</p>
                                                <p className='text'>
                                                    {vitalData?.Temperature ? `${vitalData?.Temperature} ${vitalUnitList?.Temperature}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>Pulse</p>
                                                <p className='text'>
                                                    {vitalData?.Pulse ? `${vitalData?.Pulse} ${vitalUnitList?.Pulse}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>Respiratory Rate</p>
                                                <p className='text'>
                                                    {vitalData?.['Respiratory Rate'] ? `${vitalData?.['Respiratory Rate']} ${vitalUnitList?.['Respiratory Rate']}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>O2 Saturation</p>
                                                <p className='text'>
                                                    {vitalData?.['O2 Saturation'] ? `${vitalData?.['O2 Saturation']} ${vitalUnitList?.['O2 Saturation']}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>Pain</p>
                                                <p className='text'>
                                                    {vitalData?.Pain ? `${vitalData?.Pain} ${vitalUnitList?.Pain}` : '_'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className='text font-m'>Head Circumference</p>
                                                <p className='text'>
                                                    {vitalData?.['Head Circumference'] ? `${vitalData?.['Head Circumference']} ${vitalUnitList?.['Head Circumference']}` : '_'}
                                                </p>
                                            </div>
                                        </div>)}

                                </div>
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>

                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('P')}>Problems</p>
                                    {!itemsCollapsed?.['P'] &&
                                        (<div className="d-flex flex-column gap-2 mt-12">
                                            {EncounterProblem?.length > 0 ?
                                                <div
                                                >
                                                    {EncounterProblem.map(prob => (
                                                        <div className="">
                                                            <p className='text validate-color'>{prob.DiagnosisCode}</p>
                                                            <p className='text px-1 light_bg text-nowrap validation_message my-1'>{prob.Description || noData}</p>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p className='heading'>Start Date: <span className='font-r'>{prob.StartDate || noData}</span></p>
                                                                <p className='heading'>{prob.Acuity || noData}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div> : <>{noValExistText}</>}
                                        </div>)}
                                </div>
                            </div>
                            <div className="br-bottom-1 pb-2 za_br_light">
                                <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('ON')}>Other Note</p>
                                {!itemsCollapsed?.['ON'] &&
                                    (<div className="mt-12">
                                        {isVisuallyEmpty(Data.OtherNote) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.OtherNote || '' }}></p>}
                                    </div>)}
                            </div>
                            {/* Additional Info */}
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] && (
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>)}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] && (
                                                <div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :
                    Data?.NoteType === 'Massage' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>

                            <div className='br-bottom-1 pb-2 za_br_light'>
                                {/* <div className="d-flex align-items-center justify-content-between"> */}
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Subjective')}>Subjective</p>
                                </div>
                                {!itemsCollapsed?.['Subjective'] &&
                                    (<div className="">
                                        {isVisuallyEmpty(Data.SubjectiveNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.SubjectiveNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Objective')}>Objective</p>
                                </div>
                                {!itemsCollapsed?.['Objective'] &&
                                    <div className="">
                                            {isVisuallyEmpty(Data.ObjectiveNotes) ?
                                                noValExistText :
                                                <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ObjectiveNotes || '' }}></p>}
                                    </div>}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Assessment')}>Assessment</p>
                                </div>
                                {!itemsCollapsed?.['Assessment'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            {isVisuallyEmpty(Data.AssesmentNotes) ?
                                                noValExistText :
                                                <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AssesmentNotes || '' }}></p>}
                                        </div>
                                    </div>}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Plan')}>Plan</p>
                                </div>
                                {!itemsCollapsed?.['Plan'] &&
                                    <div className="">
                                        {isVisuallyEmpty(Data.PlanNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                    </div>}
                            </div>
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] &&
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :
                    Data?.NoteType === 'Physical' ?
                        <>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                                        <HeaderIcon/>
                                    </div>
                                    {!itemsCollapsed?.['CC'] &&
                                        <div className="mt-12">
                                            {Data?.ChiefComplaint ?
                                                <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
                                        </div>}
                                </div>
                            </div>

                            <div className='br-bottom-1 pb-2 za_br_light'>
                                {/* <div className="d-flex align-items-center justify-content-between"> */}
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Subjective')}>Subjective</p>
                                </div>
                                {!itemsCollapsed?.['Subjective'] &&
                                    (<div className="">
                                        {isVisuallyEmpty(Data.SubjectiveNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.SubjectiveNotes || '' }}></p>}
                                    </div>)}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Objective')}>Objective</p>
                                </div>
                                {!itemsCollapsed?.['Objective'] &&
                                    <div className="">
                                            {isVisuallyEmpty(Data.ObjectiveNotes) ?
                                                noValExistText :
                                                <p className="text" dangerouslySetInnerHTML={{ __html: Data?.ObjectiveNotes || '' }}></p>}
                                    </div>}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Assessment')}>Assessment</p>
                                </div>
                                {!itemsCollapsed?.['Assessment'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            {isVisuallyEmpty(Data.AssesmentNotes) ?
                                                noValExistText :
                                                <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AssesmentNotes || '' }}></p>}
                                        </div>
                                    </div>}
                            </div>
                            <div className='br-bottom-1 pb-2 za_br_light'>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Plan')}>Plan</p>
                                </div>
                                {!itemsCollapsed?.['Plan'] &&
                                    <div className="">
                                        {isVisuallyEmpty(Data.PlanNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: Data?.PlanNotes || '' }}></p>}
                                    </div>}
                            </div>
                            <div className=''>
                                <div className="">
                                    <p className='heading fs-13 validate-color blue-bg w-max-content' onClick={() => handleItemsExpanded('Additional Info')}>Additional Info</p>
                                </div>
                                {!itemsCollapsed?.['Additional Info'] &&
                                    <div className='mt-12'>
                                        <div className="">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('D')}>Documents</p>
                                            {!itemsCollapsed?.['D'] &&
                                                <>
                                                    {EncounterDocument.length > 0 ?
                                                        EncounterDocument.map(doc => (
                                                            <div className="">
                                                                <p className='text validate-color mb-1'>{doc.FileName}</p>
                                                                <p className='heading mb-1'>Document Type: <span className='font-r'>{DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)} </span></p>
                                                                {/* <p className='heading mb-1'>Added Date: <span className='font-r'>12/09/2024</span></p> */}
                                                                <p className='text px-1 light_bg mb-1 text-nowrap validation_message'>{doc.Description || noData}</p>
                                                            </div>
                                                        )) : <>{noValExistText}</>}
                                                </>}
                                        </div>
                                        <div className="mt-2">
                                            <p className='heading text-decoration-underline mb-1 cursor-pointer user-select-none w-max-content' onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] &&
                                                (<div className="">
                                                    {isVisuallyEmpty(Data.AdditionalInfoNotes) ?
                                                        noValExistText :
                                                        <p className="text" dangerouslySetInnerHTML={{ __html: Data?.AdditionalInfoNotes || '' }}></p>}
                                                </div>)}
                                        </div>
                                    </div>}
                            </div>
                        </> :
                    isEncounterNotSystemGenerated ? 
                        <><CustomNoteHeaderIcon/></> : 
                    <></>}

                </div> :
                (!(isLoading || isLoadingDD || isLoadingPastEncounter) ?
                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(100vh - 400px)', }}>
                        <span className='text font-m ' style={{ fontStyle: 'italic', color: '#707070' }}>
                            No Past Encounter Found!
                        </span>
                    </div> : <></>)}
        </div>
    )
}

// export default PastEncounters
function mapStateToPropss(state) {
    return {
    };
}
const action = {
    TabActionEncounterMenu,
};

export default connect( mapStateToPropss, action)(PastEncounters);